import React from 'react';
import { Alert } from 'reactstrap';

export default function MissingDetails(props) {
  var hasEmail = false;
  var hasPhone = false;
  var hasAddress = false;
  var missing = [];
  props.user.contactdetails.forEach(function(contactDetail) {
    if (contactDetail.type === 'C') {
      hasEmail = true;
    } else if (contactDetail.type === 'F') {
      hasPhone = true;
    } else {
      hasAddress = true;
    }
  });
  if (!hasEmail) {
    missing.push('email address');
  }
  if (!hasPhone) {
    missing.push('phone number');
  }
  if (!hasAddress) {
    missing.push('postal address');
  }
  if (!missing.length) {
    return null;
  }
  var last = missing.splice(-1);
  var multMissing = missing.length;
  if (!missing.length) {
    missing= last[0];
  } else {
    missing = [missing.join(', '), last[0]].join(' and ');
  }

  return (
    <Alert color="warning" className="my-2">
      We&rsquo;re missing your { missing }. Please contact the local team to have {multMissing < 1 ? 'it': 'them'} added
    </Alert>

  );
}



// WEBPACK FOOTER //
// ./src/MissingDetails.js